import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowAlertTitle: Components<Theme>['MuiAlertTitle'] = {
  defaultProps: {
    variant: 'caption2',
    component: 'h4',
  },
};
